module.exports = __webpack_public_path__ + "img/link.8e990d6b.svg";